import React, { useState } from 'react';
import { Steps, Button, Upload, Select, Table } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { read, utils } from 'xlsx';
import axios from 'axios';
import { format } from 'date-fns'; 
import { toast } from "react-toastify";



const ImportEmployeesModal = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
const { Step } = Steps;
const { Option } = Select;
const [apiError, setApiError] = useState(null);

const [data, setData] = useState([
  { key: '1', field: 'First Name', mappedTo: '' },
  { key: '2', field: 'Last Name', mappedTo: '' },
  { key: '3', field: 'Father/Spouse Name', mappedTo: '' },
  { key: '4', field: 'Gender', mappedTo: '' },
  { key: '5', field: 'Birth Date', mappedTo: '' },
  { key: '6', field: 'Wedding Date', mappedTo: '' },
  { key: '7', field: 'Religion', mappedTo: '' },
  { key: '8', field: 'Nationality', mappedTo: '' },
  { key: '9', field: 'Phone', mappedTo: '' },
  { key: '10', field: 'Personal Email', mappedTo: '' },
  { key: '11', field: 'Marital status', mappedTo: '' },
  { key: '12', field: 'Blood Group', mappedTo: '' },
  { key: '13', field: 'Present address', mappedTo: '' },
  { key: '14', field: 'Permanent address', mappedTo: '' },
  { key: '15', field: 'Passport number', mappedTo: '' },
  { key: '16', field: 'Visa number', mappedTo: '' },
  { key: '17', field: 'PAN No', mappedTo: '' },
  { key: '18', field: 'UAN No', mappedTo: '' },
  { key: '19', field: 'EPF No', mappedTo: '' },
  { key: '20', field: 'Social Security No', mappedTo: '' },
  { key: '21', field: 'AADHAR Number', mappedTo: '' },
  { key: '22', field: 'Bank Name', mappedTo: '' },
  { key: '23', field: 'Bank A/c number', mappedTo: '' },
  { key: '24', field: 'IFSC Code', mappedTo: '' },
  { key: '25', field: 'Employee ID', mappedTo: '' },
  { key: '26', field: 'Designation', mappedTo: '' },
  { key: '27', field: 'Department', mappedTo: '' },
  { key: '28', field: 'Date Of Joining', mappedTo: '' },
  { key: '29', field: 'Work Location', mappedTo: '' },
  { key: '30', field: 'Employment Type', mappedTo: '' },
  { key: '31', field: 'Employment Status', mappedTo: '' },
  { key: '32', field: 'Date of Confirmation', mappedTo: '' },
  { key: '33', field: 'Work Preference', mappedTo: '' },
  { key: '34', field: 'Reporting to', mappedTo: '' }
]);

  const [fileData, setFileData] = useState([]);
  const [importSummary, setImportSummary] = useState(null);
  const [importBasedOn, setImportBasedOn] = useState("add-update"); // Match the defaultValue

  const [isFileUploaded, setIsFileUploaded] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const resetModal = () => {
    setCurrentStep(0);
    setColumns([]);
    setData([
      { key: '1', field: '', mappedTo: '' },
      { key: '2', field: 'First Name', mappedTo: '' },
      { key: '3', field: 'Last Name', mappedTo: '' },
      { key: '4', field: 'Gender', mappedTo: '' },
      { key: '5', field: 'Birth Date', mappedTo: '' },
      { key: '6', field: 'Wedding Date', mappedTo: '' },
      { key: '7', field: 'Religion', mappedTo: '' },
      { key: '8', field: 'Nationality', mappedTo: '' },
      { key: '9', field: 'Phone', mappedTo: '' },
      { key: '10', field: 'Personal Email', mappedTo: '' },
      { key: '11', field: 'Marital status', mappedTo: '' },
      { key: '12', field: 'Blood Group', mappedTo: '' },
      { key: '13', field: 'Present address', mappedTo: '' },
      { key: '14', field: 'Permanent address', mappedTo: '' },
      { key: '15', field: 'Passport number', mappedTo: '' },
      { key: '16', field: 'Visa number', mappedTo: '' },
      { key: '17', field: 'PAN No', mappedTo: '' },
      { key: '18', field: 'UAN No', mappedTo: '' },
      { key: '19', field: 'EPF No', mappedTo: '' },
      { key: '20', field: 'Social Security No', mappedTo: '' },
      { key: '21', field: 'AADHAR Number', mappedTo: '' },
      { key: '22', field: 'Bank Name', mappedTo: '' },
      { key: '23', field: 'Bank A/c number', mappedTo: '' },
      { key: '24', field: 'IFSC Code', mappedTo: '' },
      { key: '25', field: 'Employee ID', mappedTo: '' },
      { key: '26', field: 'Designation', mappedTo: '' },
      { key: '27', field: 'Department', mappedTo: '' },
      { key: '28', field: 'Date Of Joining', mappedTo: '' },
      { key: '29', field: 'Work Location', mappedTo: '' },
      { key: '30', field: 'Employment Type', mappedTo: '' },
      { key: '31', field: 'Employment Status', mappedTo: '' },
      { key: '32', field: 'Date of Confirmation', mappedTo: '' },
      { key: '33', field: 'Work Preference', mappedTo: '' },
      { key: '34', field: 'Reporting to', mappedTo: '' },
      // (Continue resetting the rest of the fields...)
    ]);

    
    setFileData([]);
    setImportSummary(null);
    setIsFileUploaded(false);
  };

  const next = () => {
    if (currentStep === 0 && !isFileUploaded) {
      toast.error("Please upload a file before proceeding.");
      return;
    }
    setCurrentStep(currentStep + 1);
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = read(data, { type: 'array' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const headers = utils.sheet_to_json(worksheet, { header: 1 })[0];
        const rows = utils.sheet_to_json(worksheet, { header: 1 }).slice(1);
  
        const columnOptions = headers.map((header, index) => ({
          key: index,
          label: header,
          value: header.toLowerCase().replace(/\s+/g, '_'),
        }));
        setColumns(columnOptions);
  
        // Check for date fields and format them
        const updatedRows = rows.map((row) =>
          row.map((cell, colIndex) => {
            const columnLabel = headers[colIndex]?.toLowerCase();
  
            // Detect date columns by name (e.g., "date of joining")
            if (columnLabel?.includes('date')) {
              // Convert Excel serial number to a valid JavaScript date
              if (typeof cell === 'number') {
                const date = new Date((cell - 25569) * 86400 * 1000); // Convert to JS date
                return format(date, 'yyyy-MM-dd'); // Format date (customize format as needed)
              }
            }
            return cell; // Return other cells as-is
          })
        );
  
        setFileData(updatedRows);
        setIsFileUploaded(true);
  
        // Auto map fields
        const updatedData = data.map((item) => {
          const matchedColumn = columnOptions.find((col) => col.label.toLowerCase() === item.field.toLowerCase());
          if (matchedColumn) {
            return { ...item, mappedTo: matchedColumn.value };
          }
          return item;
        });
        setData(updatedData);
      } catch (error) {
        console.error('Error parsing file:', error);
      }
    };
    reader.readAsArrayBuffer(file);
    return false; // Prevent automatic upload
  };

  const handleSelectChange = (value, key) => {
    const updatedData = data.map((item) => {
      if (item.key === key) {
        return { ...item, mappedTo: value };
      }
      return item;
    });
    setData(updatedData);
  };

  const handleAutoMap = () => {
    const updatedData = data.map((item) => {
      const matchedColumn = columns.find((col) => col.label.toLowerCase().includes(item.field.toLowerCase()));
      if (matchedColumn) {
        return { ...item, mappedTo: matchedColumn.value };
      }
      return item;
    });
    setData(updatedData);
  };
  const handleDone = async () => {
    setCurrentStep(3); // Move to step 4 to show the loader and summary section
    setLoading(true); // Start loader
    setApiError(null); // Clear any previous API errors
  
    const mappedData = fileData.map((row) => {
      const mappedRow = {};
      data.forEach((field) => {
        if (field.mappedTo) {
          mappedRow[field.field] = row[columns.findIndex((col) => col.value === field.mappedTo)];
        }
      });
      return mappedRow;
    });
  
    try {
      setImportSummary(null); // Clear any previous summary data
  
      const response = await axios.post(
        `${apiUrl}/employees/import`,
        { data: mappedData, importBasedOn },
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      if (response.status === 201) {
        setImportSummary(response.data); // Update the summary data
        toast.success("Employees processed successfully.");
      } else {
        throw new Error("Unexpected API response.");
      }
    } catch (error) {
      console.error("Import failed:", error);

      setApiError({
        message: error.response?.data?.error || "An error occurred during the import.",
        detail: error.response?.data?.detail || "No additional details available.",
      }); // Set the AP

    } finally {
      setLoading(false); // Stop loader after the process is complete
    }
  };
  
  
  

  return (
    <div className="modal custom-modal fade" id="import_employees" role="dialog">
      <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "80%" }}>
        <div className="modal-content h-100 d-flex flex-column">
          <div className="modal-header">
            <h5 className="modal-title">Import</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={resetModal}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body flex-grow-1 overflow-auto" style={{ maxHeight: "calc(100vh - 120px)" }}>
          {!importSummary && (
            <div className="selection-section">
              <div className="selection-group">
                <label>Import data for:</label>
                <Select defaultValue="Employee" style={{ width: 200 }}>
                <Option value="employee">Employee Information</Option>
                <Option value="educational">Educational Background</Option>
                <Option value="professional">Work Experience</Option>


                </Select>
              </div>
              <div className="selection-group">
                <label>Import based on:</label>
                <Select defaultValue="Add/Update Data" style={{ width: 200 }}
                onChange={(value) => setImportBasedOn(value)} // Update state on change
                >
                <Option value="add">Add New Records</Option>
                  <Option value="add-update">Add/Update Records</Option>
                  <Option value="update">Update Existing Records</Option>
                </Select>
              </div>
            </div>
            )}
            <hr></hr>
            <Steps current={currentStep}>
              <Step title="Map details" />
              <Step title="Verify" />
              <Step title="Preview Import" />
              <Step title="Import Summary" />
            </Steps>
            <div className="steps-content">
              {currentStep === 0 && (
                <div className="upload-section">
                  <Upload.Dragger name="files" multiple={false} beforeUpload={handleFileUpload}>
                    <p className="ant-upload-drag-icon">
                      <UploadOutlined />
                    </p>
                    <p className="ant-upload-text">Drag and drop attachment here</p>
                    <p className="ant-upload-hint">Only xls, xlsx, and csv formats are supported</p>
                  </Upload.Dragger>
                  <p className="upload-instructions">Maximum upload file size is 5 MB.</p>
                  <a href="#" className="download-template">Download sample template</a>
                </div>
              )}
              {currentStep === 1 && (
                <div className="map-details-section" style={{ overflowY: 'auto', maxHeight: '400px' }}>
                  <div className="mapping-container" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {data.map((item) => (
                      <div key={item.key} className="mapping-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <label>{item.field}</label>
                        <Select value={item.mappedTo} style={{ width: '60%' }} onChange={(value) => handleSelectChange(value, item.key)}>
                          {columns.map((col) => (
                            <Option key={col.key} value={col.value}>{col.label}</Option>
                          ))}
                        </Select>
                      </div>
                    ))}
                  </div>
                  <Button type="primary" className="auto-map-btn" style={{ marginTop: '16px' }} onClick={handleAutoMap}>
                    Auto Map Fields
                  </Button>
                  <Button type="secondary" className="reset-fields-btn" style={{ marginTop: '16px' }}>Reset Fields</Button>
                </div>
              )}
              {currentStep === 2 && (
                <div className="preview-import-section" style={{ overflowY: 'auto', maxHeight: '400px' }}>
                  <h5>Mapped Fields</h5>
                  <br/>
                  <Table columns={[
                      { title: 'Field', dataIndex: 'field', key: 'field' },
                      { title: 'Mapped To', dataIndex: 'mappedTo', key: 'mappedTo' },
                    ]}
                    dataSource={data.filter((item) => item.mappedTo)} pagination={false} />
                     <br/>
                  <h5>Data Preview</h5>
                  <br/>
                  <Table columns={data.filter((item) => item.mappedTo).map((item) => ({
                      title: item.field, dataIndex: item.mappedTo, key: item.mappedTo,
                    }))}
                    dataSource={fileData.slice(0, 5).map((row, index) => {
                      const rowData = {};
                      data.forEach((field) => {
                        if (field.mappedTo) {
                          rowData[field.mappedTo] = row[columns.findIndex((col) => col.value === field.mappedTo)];
                        }
                      });
                      return { key: index, ...rowData };
                    })} pagination={false} />
                </div>
              )}
{currentStep === 3 && (
  <div className="import-summary-section">
    {loading ? (
      <div id="loader-wrapper-">
        <div className="loader">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
        <p>Loading import summary, please wait...</p>
      </div>
    ) : (
      <>
        {apiError ? (
          // Show error message with "Try Again" option
          <div className="api-error">
            <h4>Import Failed</h4>
            <p>{apiError.message}</p>
            <p className="error-detail">{apiError.detail}</p>
            
            <Button type="primary" onClick={() => setCurrentStep(0)} style={{ marginTop: '16px' }}>
              Try Again
            </Button>
          </div>
        ) : !importSummary ? (
          <p>Loading import summary, please wait...</p> // Fallback in case summary is not available yet
        ) : (
          <>
            <h4>Import Summary</h4>
            <div className="summary-stats">
              <div className="summary-item">
                <p>Total Records: {importSummary.total || importSummary.success.length + importSummary.failed.length}</p>
              </div>
              <div className="summary-item">
                <p>Added/Updated: {importSummary.added || importSummary.success.length}</p>
              </div>
              <div className="summary-item">
                <p className="error-count">Errors: {importSummary.failed.length}</p>
              </div>
            </div>

            {/* Conditionally render Error Details only if there are errors */}
            {importSummary.failed.length > 0 && (
              <>
                <h4>Error Details</h4>
                <Table
                  columns={[
                    { title: 'Row No', dataIndex: 'row', key: 'row' },
                    { title: 'Name', dataIndex: 'name', key: 'name' },
                    { title: 'Reason', dataIndex: 'reason', key: 'reason' },
                  ]}
                  dataSource={importSummary.failed.map((item, index) => ({ ...item, key: index }))}
                  pagination={false}
                />
              </>
            )}
          </>
        )}
      </>
    )}
  </div>
)}


            </div>
          </div>
          <div className="modal-footer">
            {currentStep > 0 && currentStep < 3 && (
              <Button type="button" className="btn btn-secondary" style={{ margin: '0 8px' }} onClick={prev}>
                Previous
              </Button>
            )}
            {currentStep < 2 && (
              <Button type="button" className="btn btn-primary" onClick={next}>Next</Button>              
            )}
            {currentStep === 2 && (
              <Button type="button" className="btn btn-primary" onClick={handleDone}>Done</Button>
            )}
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportEmployeesModal;
